import TooltipManager from '@/directives/tooltipDirective.js'

export const initTooltip = (el, data) => {
  if (!el) return
  el.binding_value = data;
  const enterListener = function(event) {
    if (event.currentTarget !== el) return;
    if (el.binding_value.getTextFn) {
      el.binding_value.text = el.binding_value.getTextFn()
    }
    TooltipManager.getInstance().createTooltip(el);
  };

  const leaveListener = function(event) {
    if (event.currentTarget !== el) return;
    TooltipManager.getInstance().destroyTooltip(el);
  };

  el.addEventListener('mouseenter', enterListener);
  el.addEventListener('mouseleave', leaveListener);

  function unbindDirective() {
    el.removeEventListener('mouseenter', enterListener);
    el.removeEventListener('mouseleave', leaveListener);
    TooltipManager.getInstance().destroyTooltip(el);
  }
  el.unbindDirective = unbindDirective;
}
export const updateTooltip = (el, data) => {
  if (!el) return
  const instance = TooltipManager.getInstance()
  el.binding_value = data
  if (instance.tooltipInstance) {
    instance.updateTooltip(el);
  }
}
export const destroyTooltip = (el) => {
  if (!el) return
  el.unbindDirective && el.unbindDirective();
}